import config from "../Common/Configurations/APIConfig";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import auth from "../Common/Configurations/Auth";
import { handleSuccess, handleError } from "../Common/Layout/CustomAlerts";
import { Eye, EyeOff } from "lucide-react";
const initialLoginValues = {
  userName: "",
  password: "",
};
export default function Login() {
  const navigate = useNavigate();
  const [values, setValues] = useState(initialLoginValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [ipAddress, setIpAddress] = useState("0.0.0.0");
  const applicationAPI = (url = config.APIACTIVATEURL + config.LOGINUSER) => {
    return {
      userlogin: (newRecord) => axios.post(url, newRecord),
    };
  };
  useEffect(() => {
    async function GetIPAddress() {
      try {
        const response = await axios.get("https://api4.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {}
    }
    GetIPAddress();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  const validate = () => {
    let temp = {};
    temp.userName = values.userName == "" ? false : true;
    temp.password = values.password == "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x == true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        setBtnSubmit(false);
        const formData = new FormData();
        formData.append("userName", values.userName);
        formData.append("password", values.password);
        formData.append("ipAddress", ipAddress);

        checkUser(formData);
      } catch (err) {
        setBtnSubmit(true);
        handleError("Please check the mandatory fields");
      }
    } else {
      setBtnSubmit(true);
      handleError("Please check the mandatory fields");
    }
  };
  const checkUser = (loginData) => {
    applicationAPI()
      .userlogin(loginData)
      .then((res) => {
        if (res.data.statusCode === 200) {
          setBtnSubmit(true);
          setValues(initialLoginValues);

          auth.ulogin(async () => {
            localStorage.setItem("userId", res.data.userId);
            localStorage.setItem("name", res.data.name);
            localStorage.setItem("roleName", res.data.roleName);
            localStorage.setItem("userToken", res.data.token);
            localStorage.setItem("tokenexpiration", res.data.expiration);
            localStorage.setItem("userName", res.data.userName);
            localStorage.setItem("staffId", res.data.staffId);
            localStorage.setItem("clientId", res.data.clientId);
            if (res.data.roleName === "SUPERADMIN") {
              navigate("/admindashboard");
            } else if (res.data.roleName === "ADMIN") {
              navigate("/admindashboard");
            } else if (res.data.roleName === "SUBADMIN") {
              navigate("/subadmindashboard");
            } else if (res.data.roleName === "STAFF") {
              navigate("/staffdashboard");
            } else if (res.data.roleName === "CLIENT") {
              navigate("/clientdashboard");
            } else {
              handleError("Invalid login");
            }
          });
        } else {
          handleError(res.data.data);
          setBtnSubmit(true);
        }
      })
      .catch(function (error) {
        handleError(error);
        setBtnSubmit(true);
      });
  };
  useEffect(() => {
    if (localStorage.getItem("userToken") !== "") {
      if (CheckExpirationTime()) {
        navigate("/adminDashboard");
      } else {
        navigate("/");
      }
    } else {
      navigate("/");
    }
  }, []);
  function CheckExpirationTime() {
    if (localStorage.getItem("tokenexpiration") !== "") {
      const expiredate = new Date(localStorage.getItem("tokenexpiration"));
      const localdate = new Date();
      if (expiredate > localdate) {
        return true;
      }
    }
    return false;
  }
  const applyErrorClass = (field) =>
    field in errors && errors[field] == false ? " form-control-danger" : "";
  return (
    <div className="auth-back-cover">
      <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
        {/* auth-page content */}
        <div className="auth-page-content overflow-hidden mt-lg-4">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="card overflow-hidden rounded-4 loginbox">
                  <div className="row g-0">
                    <div className="p-lg-5 p-4">
                      <div
                        className="text-primary"
                        style={{ fontSize: "30px", textAlign: "center" }}
                      >
                        TEAM SRIVEN MANAGEMENT
                      </div>
                      <p className="text-muted" style={{ textAlign: "center" }}>
                        Sign in to continue...
                      </p>
                      <div className="mt-4">
                        <form
                          onSubmit={handleSubmit}
                          autoComplete="off"
                          noValidate
                        >
                          <div className="mb-3">
                            <label htmlFor="userName" className="form-label">
                              User Name
                            </label>
                            <input
                              className={
                                "form-control" + applyErrorClass("userName")
                              }
                              name="userName"
                              type="text"
                              value={values.userName}
                              onChange={handleInputChange}
                              placeholder="Please Enter User Name"
                            />
                            {errors.userName === false ? (
                              <div className="validationerror">
                                Please enter user name
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="mb-3 position-relative">
                            <label
                              htmlFor="password-input"
                              className="form-label"
                            >
                              Password
                            </label>
                            <input
                              type={showPassword.password ? "text" : "password"}
                              value={values.password}
                              name="password"
                              onChange={handleInputChange}
                              className={
                                "form-control" + applyErrorClass("password")
                              }
                              placeholder="Please Enter Password"
                            />

                            {/* Always show the eye icon */}
                            <span
                              onClick={() =>
                                togglePasswordVisibility("password")
                              }
                              style={{
                                position: "absolute",
                                top: "38px",
                                right: "10px",
                                cursor: "pointer",
                              }}
                            >
                              {showPassword.password ? (
                                <EyeOff size={18} />
                              ) : (
                                <Eye size={18} />
                              )}
                            </span>

                            {/* Show error if needed */}
                            {errors.password === false && (
                              <div className="validationerror">
                                Please enter password
                              </div>
                            )}
                          </div>

                          <div className="mt-4">
                            {btnSubmit === true ? (
                              <button
                                type="submit"
                                className="btn btn-success w-100"
                              >
                                Sign In
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-primary w-100"
                                disabled
                              >
                                Please wait...
                              </button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                    {/* end col */}
                  </div>
                  {/* end row */}
                </div>
                {/* end card */}
              </div>
              <p className="display-4 text-success position-absolute top-50 start-50"></p>
              <p className="display-5 text-success logincaption"></p>
              {/* end col */}
            </div>
            {/* end row */}
          </div>
          {/* end container */}
        </div>
        {/* end auth page content */}
        {/* footer */}
        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center d-flex justify-content-center">
                  <p className="mb-0">
                    © SRIVENFS
                    <i className="mdi mdi-heart text-danger" /> 2025
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* end Footer */}
      </div>
    </div>
  );
}
